import { render, staticRenderFns } from "./BridgeContainer.vue?vue&type=template&id=a7aff7d8&scoped=true"
import script from "./BridgeContainer.vue?vue&type=script&lang=js"
export * from "./BridgeContainer.vue?vue&type=script&lang=js"
import style0 from "./BridgeContainer.vue?vue&type=style&index=0&id=a7aff7d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7aff7d8",
  null
  
)

export default component.exports